import { prefix } from '@root/utils/Lang';

const modulePrefix = 'module.order';

const translations = {
  'order': 'Megrendelések',

  'id.title': 'Megrendelésszám',
  'created_at.title': 'Dátum',
  'user.id.title': 'Felhasználó ID',
  'user.ext_id.title': 'Felhasználói azonosító',
  'contact_data.contact_name.title': 'Megrendelő',
  'contact_data.contact_telephone.title': 'Telefon',
  'total_amount.title': 'Összérték',
  'total_sum.title': 'Összérték',
  'status.title.title': 'Státusz',
  'status.code.title': 'Státusz',
  'shipping_method.name.title': 'Szállítási mód',
  'payment_method.name.title': 'Fizetési mód',
  'payment_method_cost.title': 'Utánvét díja',
  'erp_comment.title': 'ERP megjegyzés',
  'comment.title': 'Megjegyzés',
  'user.title': 'Felhasználó',
  'linked_order_id.title': 'Kapcsolt főrendelés',

  'contact_data.contact_name': 'Megrendelő',
  'contact_data.contact_telephone': 'Telefon',
  'contact_data.contact_email': 'E-mail',

  'billing_block.title': 'Számlázási cím',
  'billing_name': 'Számlázási név',
  'billing_address': 'Számlázási cím',

  'shipping_block.title': 'Szállítási cím',
  'shipping_name': 'Szállítási név',
  'shipping_address': 'Szállítási cím',
  'shipping_note': 'Megjegyzés',
  'shipping_cost': 'Szállítási költség',

  'donation_block.title': 'Adományozás',
  'donation_type': 'Típus',
  'donation_type.ROUND': 'Kerekített',
  'donation_type.UNIQUE': 'Egyedi összegű',
  'donation_amount': 'Összeg',

  'shipping_post_point.title': 'Postapont',
  'shipping_timetable.title': 'GRoby házhozszállítás',
  'sector': 'Szektor',
  'range': 'Idősáv',

  'shipping_method_id.please_select': 'Szállítási mód...',
  'status_code.please_select': 'Státusz...',

  'filter.id': 'Megrendelésszám',
  'filter.create_at_from': 'Dátum -tól',
  'filter.create_at_to': 'Dátum -ig',
  'filter.user_ext_id': 'Felhasználó azonosító',
  'filter.contact_data.contact_name': 'Megrendelő',
  'filter.status': 'Státusz',
  'filter.shipping_method': 'Szállítási mód',
  'filter.payment_method': 'Fizetési mód',
  'filter.is_admin_checked.all': 'Admin által kezelve (összes)',

  'products.title': 'Termékek',
  'linked_orders.title': 'Kapcsolt megrendelések',

  'tabs.labels.profile': 'Alapadatok',
  'tabs.labels.history': 'Előzmények',

  'history.created_at': 'Dátum',
  'history.modified_field': 'Mező',
  'history.modified_from': 'Eredeti érték',
  'history.modified_to': 'Új érték',
  'history.modified_by': 'Módosító admin',
  'history.is_admin_checked': 'Admin által kezelve',

  'history.synchronized': 'Szinkronizált',
  'history.total_amount': 'Végösszeg',
  'history.shipping_cost': 'Szállítási költség',
  'history.timetable_time_slot.sector.name': 'Szektor',
  'history.timetable_time_slot.sector.timeSlots.status': 'Státusz',
  'history.timetable_time_slot.range_date': 'Dátum',
  'history.timetable_time_slot.timeRange.time_from': 'Időpont -tól ',
  'history.timetable_time_slot.timeRange.time_to': 'Időpont -ig',
  'history.post_point.id': 'Postapont',
  'history.shipping_method.id': 'Szállítási mód',
  'history.payment_method.id': 'Fizetési mód',
  'history.linked_order.id': 'Kapcsolt megrendelés',
  'history.comment': 'Megjegyzés',
  'history.status.title': 'Státusz',

  'history.modified_by_user': 'Felhasználó',
  'history.no_data': 'Nincs megjeleníthető előzmény.',

  'additional_information.key.color': 'Masni színe',
  'additional_information.key.giftCardText': 'Ajándékkártya szövege',

  'new_customer.label': 'Új vásárló',

  'coupon.title': 'Kupon',
  'coupon.product_discount': 'termékkedvezmény',
  'coupon.shipping_discount': 'szállítási díj kedvezmény',

  'product.sliced': 'Szeletelve kérem',
};

export default prefix(modulePrefix, translations);



// WEBPACK FOOTER //
// ./src/modules/Order/lang/hu.ts